<div class="container p-8 pt-7">
  <rd-shared-icon
    class="m-0 mb-3 lg:mb-2.5"
    [iconSymbol]="'icon-linked'"
    [iconTheme]="'success'"></rd-shared-icon>

  <h1 class="title m-0">
    {{ 'transfer_v2.membership_success_dialog.title' | translate }}
  </h1>

  <p class="description m-0 mt-3">
    {{
      'transfer_v2.membership_success_dialog.description'
        | translate
          : {
              loyaltyProgramShortName: loyaltyProgramShortName
            }
    }}
  </p>

  <rd-shared-button
    class="ok-button mx-auto mb-0 mt-3"
    [buttonClass]="'ok-button'"
    [buttonContent]="okButtonContent"
    [buttonTheme]="buttonTheme"
    (clickFn)="closeDialog()">
    <ng-template #okButtonContent>
      <span class="ok-button-text">{{
        'transfer_v2.membership_success_dialog.ok_text' | translate
      }}</span>
    </ng-template>
  </rd-shared-button>
</div>
